import React, { useState, useEffect } from 'react';
import Navbar from '../../../Components/Navbar/Navbar';
import {
    Layout,
} from 'antd';

function System36TeamGame() {

    return (
        <Layout className='page'>
            <Navbar navKey={'system_36_team_nav'} />
        </Layout>
    );
}

export default System36TeamGame;
